<template>
  <Modal :open="open" @close="closeModal">
    <div class="space-y-4">
      <h3 class="text-lg font-medium text-gray-900">Modifier le vendeur</h3>
      <div>
        <label for="sellerId" class="block text-sm font-medium text-gray-700">
          Vendeur
          <span class="ml-1 text-red-600">*</span>
        </label>
        <div class="mt-1">
          <div v-if="isLoadingSellers" class="text-sm text-gray-500">Chargement des vendeurs...</div>
          <div v-else-if="sellerOptions.length === 0" class="text-sm text-red-600">
            Aucun vendeur disponible pour ce magasin
          </div>
          <Selector
            v-else
            id="sellerId"
            name="sellerId"
            :options="sellerOptions"
            v-model="sellerId"
            defaultOptionText="Sélectionnez un vendeur"
            :disabled="isLoadingSellers"
          />
        </div>
        <p class="mt-1 text-sm text-gray-500">Sélectionnez le nouveau vendeur à assigner à cette vente.</p>
      </div>

      <div class="flex justify-end space-x-3 pt-4">
        <SecondaryButton type="button" @click="closeModal">Annuler</SecondaryButton>
        <GenericButton v-if="sellerId" @click="update" :disabled="isLoading">
          {{ isLoading ? "Mise à jour..." : "Mettre à jour" }}
        </GenericButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Modal, SecondaryButton, Selector, GenericButton } from "@estaly/ui";
import { mapActions, mapState } from "vuex";

export default {
  name: "UpdateSellerModal",

  components: {
    GenericButton,
    Modal,
    SecondaryButton,
    Selector,
  },

  props: {
    open: {
      type: Boolean,
      default: false,
    },
    planSale: {
      type: Object,
      required: true,
    },
  },

  emits: ["close", "updated"],

  data() {
    return {
      sellerId: null,
      isLoading: false,
      isLoadingSellers: false,
    };
  },

  computed: {
    ...mapState("sellers", { sellers: (state) => state.index }),

    sellerOptions() {
      return this.sellers.map((seller) => ({
        value: seller.id,
        label: `${seller.firstName} ${seller.lastName} (${seller.email})`,
      }));
    },
  },

  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("planSales", ["updateSeller"]),
    ...mapActions("sellers", ["fetchIndex"]),

    closeModal() {
      this.$emit("close");
    },

    async fetchSellers() {
      if (!this.planSale?.storeId) return;

      this.isLoadingSellers = true;
      try {
        await this.fetchIndex({ storeId: this.planSale.storeId });
      } catch (error) {
        console.error("Error fetching sellers:", error);
      } finally {
        this.isLoadingSellers = false;
      }
    },

    async update() {
      this.isLoading = true;

      const response = await this.updateSeller({
        planSale: this.planSale,
        sellerId: this.sellerId,
      });

      if (response?.success) {
        await this.notify({
          category: "simple",
          type: "success",
          title: "Le vendeur a été mis à jour avec succès.",
        });

        this.$emit("updated");
        this.closeModal();
      }

      this.isLoading = false;
    },
  },

  watch: {
    async open(newValue) {
      if (newValue) {
        this.sellerId = this.planSale.seller.id;
        await this.fetchSellers();
      }
    },
  },
};
</script>
